import { css } from "styled-components";

export const popoverStyle = css`
    .popover-menu-content {
        .popover-menu-item-link {
            color: var(--dit-layout-color-link--map);

            &[data-highlighted] {
                color: var(--dit-layout-color-link-hover--map);
                text-decoration: underline;
            }
        }
        [data-part="item"][data-highlighted] {
            cursor: pointer;
        }
    }
`;
